import {
	Experimental_CssVarsProvider as CssVarsProvider,
	experimental_extendTheme as extendTheme,
} from "@mui/material/styles";
import ThemeSet from "./themeSet.json";
import * as ImagesMewahgps from "@assets/images/mewahgps";
import * as ImagesGreenhaul from "@assets/images/greenhaul";

const key = (process.env.REACT_APP_GPS_COMPANY || "").toLowerCase();

function withBase(base, obj) {
	return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, `${base}${v}`]));
}

const themeSwapper = () => {
	const selected = ThemeSet[key];
	if (!selected) {
		throw new Error(
			`Unknown company theme "${key}". Options: ${Object.keys(ThemeSet).join(", ")}`
		);
	}
	return selected;
};

const themeBuilder = (cfg) => {
	return extendTheme({
		colorSchemes: {
			light: {
				palette: {
					primary: { main: cfg.primary },
					secondary: { main: cfg.secondary },
					background: { default: cfg.backgroundDefault, paper: cfg.backgroundPaper },
					text: { primary: cfg.textPrimary, secondary: cfg.textSecondary },
				},
			},
		},
		shape: { borderRadius: cfg.borderRadius ?? 8 },
		components: {
			MuiButton: {
				styleOverrides: {
					contained: ({ theme }) => ({
						height: "45px",
						// width: "100%",
						backgroundColor: theme.vars.palette.primary.main,
						"&:hover": { backgroundColor: theme.vars.palette.primary.dark },
					}),
				},
			},
			MuiInputBase: {
				styleOverrides: {
					root: ({ theme }) => ({
						background: "white !important",
						height: "45px",
						boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25) !important",
						padding: "0 10px !important",
					}),
				},
			},
			MuiCheckbox: {
				styleOverrides: {
					root: {
						height: "15px !important",
						boxShadow: "0px 4px 4px rgba(0, 0, 0, 0)!important",
					},
				},
			},
			MuiInputLabel: {
				styleOverrides: {
					outlined: {
						transform: "translate(14px, 50%) scale(1)", // Adjust the initial position
						"&.MuiInputLabel-shrink": {
							transform: "translate(14px, -6px) scale(0.75)", // Adjust the position when shrunk (label is smaller and moved up)
						},
					},
				},
			},
			MuiPickersCalendarHeader: {
				styleOverrides: {
					root: {
						padding: "30px 0 0 45px !important",
					},
				},
			},
			MuiPickersArrowSwitcher: {
				styleOverrides: {
					root: {
						marginLeft: "45px !important",
					},
				},
			},
			MuiPickersDay: {
				styleOverrides: {
					root: ({ theme }) => ({
						"Mui-selected": {
							backgroundColor: theme.vars.palette.primary.main,
						},
					}),
				},
			},
			MuiPickersToolbar: {
				styleOverrides: {
					root: {
						marginLeft: "30px !important",
						marginTop: "30px !important",
					},
				},
			},
			MuiDialogActions: {
				styleOverrides: {
					root: {
						marginBottom: "30px !important",
						marginRight: "10px !important",
					},
				},
			},
			MuiTextField: {
				styleOverrides: {
					root: {
						width: "100% !important",
						height: "100% !important",
					},
				},
			},
			MuiIconButton: {
				styleOverrides: {
					root: {
						marginRight: "8px !important",
					},
				},
			},
			MuiPickersCalendarHeader: {
				styleOverrides: {
					root: {
						marginTop: "30px !important",
						marginBottom: "15px !important",
					},
				},
			},
			MuiPickersSlideTransition: {
				styleOverrides: {
					root: {
						marginRight: "8px !important",
					},
				},
			},
			MuiTooltip: {
				styleOverrides: {
					tooltip: {
						padding: "3px 6px !important",
					},
				},
			},
			MuiMenuItem: {
				styleOverrides: {
					root: {
						minHeight: "40px !important", // Increase menu item height
						padding: "0px 12px !important",
					},
				},
			},
		},
	});
};

const IMAGE_MODULES = {
	mewahgps: ImagesMewahgps,
	greenhaul: ImagesGreenhaul,
};

const imageSwapper = () => {
	// const imageBase = "@assets/images/";
	const selected = IMAGE_MODULES[key];
	if (!selected) {
		throw new Error(
			`Unknown company images "${key}". Options: ${Object.keys(IMAGE_MODULES).join(", ")}`
		);
	}
	return selected;
};

const raw = ThemeSet[key] || ThemeSet.default;
const MuiTheme = themeBuilder(raw);
const Theme = themeSwapper();
const Image = imageSwapper();

export { Theme, Image, MuiTheme };
